export const VO_BIRTHDAY_GIFTS = [
  { id: "cake", emoji: "🎂", label: "Bolo" },
  { id: "gift", emoji: "🎁", label: "Presente" },
  { id: "flowers", emoji: "🌸", label: "Flores" },
  { id: "balloon", emoji: "🎈", label: "Balão" },
  { id: "coffee", emoji: "☕", label: "Café" },
  { id: "clap", emoji: "👏", label: "Aplauso" },
];

export function birthdayGiftById(id) {
  return VO_BIRTHDAY_GIFTS.find((item) => item.id === id) || VO_BIRTHDAY_GIFTS[0];
}

export function isBirthdayFlag(person) {
  return Boolean(person?.isBirthday || person?.is_birthday);
}

export function birthdayPeople(people = []) {
  return (Array.isArray(people) ? people : []).filter((row) => isBirthdayFlag(row) && Number(row.userId) > 0);
}

export function birthdayBannerText(people = []) {
  const names = birthdayPeople(people)
    .map((row) => String(row.userName || "").trim().split(/\s+/)[0])
    .filter(Boolean);
  if (!names.length) return "";
  if (names.length === 1) return `Hoje é aniversário de ${names[0]}`;
  if (names.length === 2) return `Hoje é aniversário de ${names[0]} e ${names[1]}`;
  return `Hoje tem ${names.length} aniversários no piso`;
}

export function wishPreview(wish) {
  const gift = birthdayGiftById(wish?.gift);
  const who = String(wish?.fromName || "Colega").trim().split(/\s+/)[0] || "Colega";
  const note = String(wish?.message || "").trim();
  return note ? `${gift.emoji} ${who}: ${note}` : `${gift.emoji} ${who} mandou parabéns`;
}
